import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesPage.css';

const ServicesPage = () => {
  return (
    <div className="services-page">
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="page-header-container">
          <div className="container">
            <h1 className="page-title">
              Our <span className="highlight">Services</span>
            </h1>
            <p className="page-subtitle">
              Comprehensive solutions to enhance your manufacturing capabilities
            </p>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="services-content">
          <h2 className="section-title">
            Our <span className="highlight">Service Offerings</span>
          </h2>
          
          <div className="service-items" style={{marginTop: '2rem', marginBottom: '3rem'}}>
            <Link to="/contact" className="service-card-link">
              <div id="1" className="service-card" style={{padding: '2rem', marginBottom: '2rem', backgroundColor: '#f8f9fa', borderRadius: '10px'}}>
                <h3>Custom Tool Design</h3>
                <p>We create custom-designed tools tailored to your specific manufacturing requirements. Our engineering team works closely with you to understand your needs and develop precision tools that enhance your production processes.</p>
                <p>We use high-quality materials and advanced design techniques to ensure optimal performance and durability of your custom tools.</p>
                <div className="contact-cta-btn">Contact Us For Details</div>
              </div>
            </Link>
            
            <Link to="/contact" className="service-card-link">
              <div id="2" className="service-card" style={{padding: '2rem', marginBottom: '2rem', backgroundColor: '#f8f9fa', borderRadius: '10px'}}>
                <h3>Tech Consultation</h3>
                <p>Our team of specialists provides expert advice to optimize your production processes, improve efficiency, and select the perfect tools for your application.</p>
                <p>We analyze your current workflows and recommend strategic improvements to enhance productivity and reduce operational costs.</p>
                <div className="contact-cta-btn">Request Consultation</div>
              </div>
            </Link>

            <Link to="/contact" className="service-card-link">
              <div id="3" className="service-card" style={{padding: '2rem', marginBottom: '2rem', backgroundColor: '#f8f9fa', borderRadius: '10px'}}>
                <h3>Tool Reconditioning</h3>
                <p>Extend the life of your tungsten carbide and diamond tools with our professional reconditioning services. We restore worn tools to like-new condition, maximizing your investment.</p>
                <p>Our reconditioning process includes thorough inspection, precision grinding, and quality testing to ensure optimal performance.</p>
                <div className="contact-cta-btn">Get Service Quote</div>
              </div>
            </Link>

            <Link to="/contact" className="service-card-link">
              <div id="4" className="service-card" style={{padding: '2rem', marginBottom: '2rem', backgroundColor: '#f8f9fa', borderRadius: '10px'}}>
                <h3>Global Distribution</h3>
                <p>We offer fast and reliable delivery of our products to industries worldwide, including aerospace, automotive, electronics, and precision manufacturing.</p>
                <p>Our global logistics network ensures that you receive your tools when and where you need them, with tracking and support throughout the shipping process.</p>
                <div className="contact-cta-btn">Inquire About Shipping</div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
